// =============================================
// O. FILES — 72H SALE POPUP ENGINE
// April 6th 2026
// =============================================
// Listens for add-to-cart events, checks if the
// added product qualifies for a sale concept,
// and shows a popup offering complimentary items
// with variant/size selection.
// =============================================

(function () {
  'use strict';

  // ─── CONFIGURATION ───────────────────────────
  // Update handles here if product URLs change.
  // Each rule: trigger handle → array of reward products.
  // ──────────────────────────────────────────────

  var HAT_PRODUCTS = [
    { handle: 'aged-baseball-cap-in-military-green', label: 'Military Green' },
    { handle: 'aged-baseball-cap-in-vintage-charcoal', label: 'Vintage Charcoal' }
    // ↑ VERIFY THESE HANDLES — update if different in Shopify admin
  ];

  var SALE_RULES = [
    // ── CONCEPT 1: Black Raglan → Complimentary Mojave Raglan + Hat ──
    {
      id: 'raglan-black',
      triggers: ['raglan-zip-hoodie-in-vintage-black'],
      heading: 'INCLUDED WITH YOUR ORDER',
      subheading: 'Select your complimentary items',
      rewards: [
        {
          type: 'single',
          label: 'RAGLAN ZIP HOODIE',
          handles: ['raglan-zip-hoodie-in-mojave']
        },
        {
          type: 'choice',
          label: 'AGED BASEBALL CAP',
          handles: HAT_PRODUCTS.map(function (h) { return h.handle; }),
          choiceLabels: HAT_PRODUCTS.map(function (h) { return h.label; })
        }
      ]
    },

    // ── CONCEPT 2: Mojave Raglan (50% off via Shopify discount) → Hat ──
    {
      id: 'raglan-mojave',
      triggers: ['raglan-zip-hoodie-in-mojave'],
      heading: 'INCLUDED WITH YOUR ORDER',
      subheading: 'Select your complimentary cap',
      rewards: [
        {
          type: 'choice',
          label: 'AGED BASEBALL CAP',
          handles: HAT_PRODUCTS.map(function (h) { return h.handle; }),
          choiceLabels: HAT_PRODUCTS.map(function (h) { return h.label; })
        }
      ]
    },

    // ── CONCEPT 3: LOT-05 → Choice of Mojave Raglan OR Scuba Jacket + Hat ──
    {
      id: 'lot-05',
      triggers: ['lot-05-denim-jeans-in-broken-indigo'],
      heading: 'INCLUDED WITH YOUR ORDER',
      subheading: 'Choose your complimentary jacket & cap',
      rewards: [
        {
          type: 'visual-choice',
          label: 'SELECT ONE',
          handles: ['raglan-zip-hoodie-in-mojave', 'scuba-jacket-in-black'],
          choiceLabels: ['Raglan Zip Hoodie — Mojave', 'Scuba Jacket — Black']
        },
        {
          type: 'choice',
          label: 'AGED BASEBALL CAP',
          handles: HAT_PRODUCTS.map(function (h) { return h.handle; }),
          choiceLabels: HAT_PRODUCTS.map(function (h) { return h.label; })
        }
      ]
    },

    // ── CONCEPT 4: Henley Black → Complimentary Sage Henley ──
    {
      id: 'henley-black',
      triggers: ['henley-long-sleeve-in-black'],
      heading: 'INCLUDED WITH YOUR ORDER',
      subheading: 'Your complimentary Henley',
      rewards: [
        {
          type: 'single',
          label: 'HENLEY LONG SLEEVE',
          handles: ['henley-long-sleeve-in-vintage-sage']
        }
      ]
    },

    // ── CONCEPT 4b: Henley Sage → Complimentary Black Henley ──
    {
      id: 'henley-sage',
      triggers: ['henley-long-sleeve-in-vintage-sage'],
      heading: 'INCLUDED WITH YOUR ORDER',
      subheading: 'Your complimentary Henley',
      rewards: [
        {
          type: 'single',
          label: 'HENLEY LONG SLEEVE',
          handles: ['henley-long-sleeve-in-black']
        }
      ]
    },

    // ── CONCEPT 5: Any Knit → Another Knit + Hat ──
    {
      id: 'knit-drape-sahara',
      triggers: ['drape-knit-in-sahara-melange'],
      heading: 'INCLUDED WITH YOUR ORDER',
      subheading: 'Choose your complimentary knit & cap',
      rewards: [
        {
          type: 'choice',
          label: 'SELECT YOUR KNIT',
          handles: [
            'drape-knit-in-charcoal-melange',
            'v-neck-knit-in-bark',
            'v-neck-knit-in-charcoal-melange'
          ],
          choiceLabels: [
            'Drape Knit — Charcoal Mélange',
            'V-Neck Knit — Bark',
            'V-Neck Knit — Charcoal Mélange'
          ]
        },
        {
          type: 'choice',
          label: 'AGED BASEBALL CAP',
          handles: HAT_PRODUCTS.map(function (h) { return h.handle; }),
          choiceLabels: HAT_PRODUCTS.map(function (h) { return h.label; })
        }
      ]
    },
    {
      id: 'knit-drape-charcoal',
      triggers: ['drape-knit-in-charcoal-melange'],
      heading: 'INCLUDED WITH YOUR ORDER',
      subheading: 'Choose your complimentary knit & cap',
      rewards: [
        {
          type: 'choice',
          label: 'SELECT YOUR KNIT',
          handles: [
            'drape-knit-in-sahara-melange',
            'v-neck-knit-in-bark',
            'v-neck-knit-in-charcoal-melange'
          ],
          choiceLabels: [
            'Drape Knit — Sahara Mélange',
            'V-Neck Knit — Bark',
            'V-Neck Knit — Charcoal Mélange'
          ]
        },
        {
          type: 'choice',
          label: 'AGED BASEBALL CAP',
          handles: HAT_PRODUCTS.map(function (h) { return h.handle; }),
          choiceLabels: HAT_PRODUCTS.map(function (h) { return h.label; })
        }
      ]
    },
    {
      id: 'knit-vneck-bark',
      triggers: ['v-neck-knit-in-bark'],
      heading: 'INCLUDED WITH YOUR ORDER',
      subheading: 'Choose your complimentary knit & cap',
      rewards: [
        {
          type: 'choice',
          label: 'SELECT YOUR KNIT',
          handles: [
            'drape-knit-in-sahara-melange',
            'drape-knit-in-charcoal-melange',
            'v-neck-knit-in-charcoal-melange'
          ],
          choiceLabels: [
            'Drape Knit — Sahara Mélange',
            'Drape Knit — Charcoal Mélange',
            'V-Neck Knit — Charcoal Mélange'
          ]
        },
        {
          type: 'choice',
          label: 'AGED BASEBALL CAP',
          handles: HAT_PRODUCTS.map(function (h) { return h.handle; }),
          choiceLabels: HAT_PRODUCTS.map(function (h) { return h.label; })
        }
      ]
    },
    {
      id: 'knit-vneck-charcoal',
      triggers: ['v-neck-knit-in-charcoal-melange'],
      heading: 'INCLUDED WITH YOUR ORDER',
      subheading: 'Choose your complimentary knit & cap',
      rewards: [
        {
          type: 'choice',
          label: 'SELECT YOUR KNIT',
          handles: [
            'drape-knit-in-sahara-melange',
            'drape-knit-in-charcoal-melange',
            'v-neck-knit-in-bark'
          ],
          choiceLabels: [
            'Drape Knit — Sahara Mélange',
            'Drape Knit — Charcoal Mélange',
            'V-Neck Knit — Bark'
          ]
        },
        {
          type: 'choice',
          label: 'AGED BASEBALL CAP',
          handles: HAT_PRODUCTS.map(function (h) { return h.handle; }),
          choiceLabels: HAT_PRODUCTS.map(function (h) { return h.label; })
        }
      ]
    }
  ];

  // ─── HAT WATCHDOG MAP ─────────────────────────
  // Only hats need the cart watchdog (other rewards
  // are protected by Shopify discount rules).
  // Maps each hat handle to ALL trigger handles that
  // could have added it via the popup.
  // ──────────────────────────────────────────────
  var HAT_HANDLES = HAT_PRODUCTS.map(function (h) { return h.handle; });

  var HAT_TRIGGERS = {};
  SALE_RULES.forEach(function (rule) {
    rule.rewards.forEach(function (reward) {
      reward.handles.forEach(function (rewardHandle) {
        if (HAT_HANDLES.indexOf(rewardHandle) === -1) return; // Skip non-hats
        if (!HAT_TRIGGERS[rewardHandle]) {
          HAT_TRIGGERS[rewardHandle] = [];
        }
        rule.triggers.forEach(function (triggerHandle) {
          if (HAT_TRIGGERS[rewardHandle].indexOf(triggerHandle) === -1) {
            HAT_TRIGGERS[rewardHandle].push(triggerHandle);
          }
        });
      });
    });
  });

  // ─── STATE ───────────────────────────────────
  var popupOpen = false;
  var productCache = {};
  var lastCartItems = [];
  var isValidating = false;

  // ─── PRODUCT DATA FETCHER ────────────────────
  // Uses .js endpoint (not .json) because it includes
  // variant availability data (available: true/false).
  function fetchProduct(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        productCache[handle] = product;
        return product;
      })
      .catch(function (err) {
        console.error('[sale-popup] Failed to fetch product:', handle, err);
        return null;
      });
  }

  // ─── DETECT NEW ITEMS IN CART ────────────────
  function getCartItems() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return cart.items || [];
      })
      .catch(function () { return []; });
  }

  function findNewlyAddedHandles(oldItems, newItems) {
    var oldHandles = {};
    oldItems.forEach(function (item) {
      var h = item.handle;
      oldHandles[h] = (oldHandles[h] || 0) + item.quantity;
    });

    var added = [];
    newItems.forEach(function (item) {
      var h = item.handle;
      var oldQty = oldHandles[h] || 0;
      if (item.quantity > oldQty) {
        added.push(h);
      }
    });
    return added;
  }

  // ─── MATCH RULES ────────────────────────────
  function findMatchingRule(handles) {
    for (var i = 0; i < SALE_RULES.length; i++) {
      var rule = SALE_RULES[i];
      for (var j = 0; j < rule.triggers.length; j++) {
        if (handles.indexOf(rule.triggers[j]) !== -1) {
          return rule;
        }
      }
    }
    return null;
  }

  // ─── BUILD POPUP ─────────────────────────────
  function buildPopup(rule, productsMap) {
    // Overlay
    var overlay = document.createElement('div');
    overlay.className = 'ofiles-sale-overlay';

    // Modal
    var modal = document.createElement('div');
    modal.className = 'ofiles-sale-modal';

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.className = 'ofiles-sale-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';
    modal.appendChild(closeBtn);

    // Heading
    var heading = document.createElement('h2');
    heading.className = 'ofiles-sale-heading';
    heading.textContent = rule.heading;
    modal.appendChild(heading);

    // Subheading
    var sub = document.createElement('p');
    sub.className = 'ofiles-sale-subheading';
    sub.textContent = rule.subheading;
    modal.appendChild(sub);

    // Reward sections
    var rewardContainer = document.createElement('div');
    rewardContainer.className = 'ofiles-sale-rewards';

    rule.rewards.forEach(function (reward, rewardIndex) {
      var section = document.createElement('div');
      section.className = 'ofiles-sale-reward';
      section.setAttribute('data-reward-index', rewardIndex);

      // Label row
      var label = document.createElement('div');
      label.className = 'ofiles-sale-reward-label';
      label.textContent = reward.label;
      section.appendChild(label);

      // ── VISUAL CHOICE: side-by-side product cards ──
      if (reward.type === 'visual-choice') {
        var cardsRow = document.createElement('div');
        cardsRow.className = 'ofiles-sale-cards';

        var selectedHandle = { value: null };

        reward.handles.forEach(function (handle, idx) {
          var product = productsMap[handle];
          var card = document.createElement('div');
          card.className = 'ofiles-sale-card';
          card.setAttribute('data-handle', handle);

          // Card image
          var cardImg = document.createElement('img');
          cardImg.className = 'ofiles-sale-card-img';
          var src = product ? (product.featured_image || (product.images && product.images[0])) : null;
          if (src) {
            cardImg.src = 'https:' + src.replace(/\.([a-z]+)(\?.*)?$/, '_300x.$1$2');
            cardImg.alt = product.title || '';
          }
          card.appendChild(cardImg);

          // Card product name
          var cardName = document.createElement('div');
          cardName.className = 'ofiles-sale-card-name';
          cardName.textContent = reward.choiceLabels ? reward.choiceLabels[idx] : (product ? product.title : handle);
          card.appendChild(cardName);

          // Card size select
          var cardSize = document.createElement('select');
          cardSize.className = 'ofiles-sale-select ofiles-sale-size-select ofiles-sale-card-size';
          cardSize.setAttribute('data-reward-index', rewardIndex);
          cardSize.setAttribute('data-card-handle', handle);

          if (product && product.variants) {
            var avail = product.variants.filter(function (v) { return v.available; });
            var oneSize = isOneSizeProduct(avail);
            avail.forEach(function (v) {
              var opt = document.createElement('option');
              opt.value = v.id;
              opt.textContent = v.title === 'Default Title' ? 'One Size' : v.title;
              cardSize.appendChild(opt);
            });
            if (oneSize) cardSize.style.display = 'none';
          }
          card.appendChild(cardSize);

          // Card select button
          var cardBtn = document.createElement('button');
          cardBtn.className = 'ofiles-sale-card-btn';
          cardBtn.textContent = 'SELECT';
          cardBtn.type = 'button';
          card.appendChild(cardBtn);

          // Card click handler — select this card, deselect others
          function selectCard(targetCard, targetHandle) {
            var allCards = cardsRow.querySelectorAll('.ofiles-sale-card');
            allCards.forEach(function (c) {
              c.classList.remove('is-selected');
              c.querySelector('.ofiles-sale-card-btn').textContent = 'SELECT';
            });
            targetCard.classList.add('is-selected');
            targetCard.querySelector('.ofiles-sale-card-btn').textContent = 'SELECTED';
            selectedHandle.value = targetHandle;
          }

          cardBtn.addEventListener('click', function () { selectCard(card, handle); });
          card.addEventListener('click', function (e) {
            if (e.target.tagName !== 'SELECT' && e.target.tagName !== 'OPTION') {
              selectCard(card, handle);
            }
          });

          // Auto-select first card
          if (idx === 0) {
            card.classList.add('is-selected');
            cardBtn.textContent = 'SELECTED';
            selectedHandle.value = handle;
          }

          cardsRow.appendChild(card);
        });

        section.appendChild(cardsRow);

        // Store reference so ADD TO BAG can read it
        section.setAttribute('data-visual-choice', 'true');
        section._selectedHandle = selectedHandle;
        section._cardsRow = cardsRow;

      // ── DROPDOWN CHOICE ──
      } else if (reward.type === 'choice' && reward.handles.length > 1) {
        var row = document.createElement('div');
        row.className = 'ofiles-sale-reward-row';

        var imgCol = document.createElement('div');
        imgCol.className = 'ofiles-sale-reward-img-col';
        var img = document.createElement('img');
        img.className = 'ofiles-sale-reward-img';
        img.setAttribute('data-reward-index', rewardIndex);
        imgCol.appendChild(img);
        row.appendChild(imgCol);

        var detailsCol = document.createElement('div');
        detailsCol.className = 'ofiles-sale-reward-details';

        var productSelect = document.createElement('select');
        productSelect.className = 'ofiles-sale-select ofiles-sale-product-select';
        productSelect.setAttribute('data-reward-index', rewardIndex);

        reward.handles.forEach(function (handle, idx) {
          var opt = document.createElement('option');
          opt.value = handle;
          opt.textContent = reward.choiceLabels ? reward.choiceLabels[idx] : handle;
          productSelect.appendChild(opt);
        });

        detailsCol.appendChild(productSelect);

        var sizeSelect = document.createElement('select');
        sizeSelect.className = 'ofiles-sale-select ofiles-sale-size-select';
        sizeSelect.setAttribute('data-reward-index', rewardIndex);
        detailsCol.appendChild(sizeSelect);

        populateSizeSelect(sizeSelect, img, reward.handles[0], productsMap);

        productSelect.addEventListener('change', function () {
          populateSizeSelect(sizeSelect, img, productSelect.value, productsMap);
        });

        row.appendChild(detailsCol);
        section.appendChild(row);

      // ── SINGLE PRODUCT ──
      } else {
        var rowS = document.createElement('div');
        rowS.className = 'ofiles-sale-reward-row';

        var imgColS = document.createElement('div');
        imgColS.className = 'ofiles-sale-reward-img-col';
        var imgS = document.createElement('img');
        imgS.className = 'ofiles-sale-reward-img';
        imgS.setAttribute('data-reward-index', rewardIndex);
        imgColS.appendChild(imgS);
        rowS.appendChild(imgColS);

        var detailsColS = document.createElement('div');
        detailsColS.className = 'ofiles-sale-reward-details';

        var handleS = reward.handles[0];
        var productS = productsMap[handleS];

        var nameS = document.createElement('div');
        nameS.className = 'ofiles-sale-product-name';
        nameS.textContent = productS ? productS.title : handleS;
        detailsColS.appendChild(nameS);

        var imgSrcS = productS ? (productS.featured_image || (productS.images && productS.images[0])) : null;
        if (imgSrcS) {
          imgS.src = 'https:' + imgSrcS.replace(/\.([a-z]+)(\?.*)?$/, '_300x.$1$2');
          imgS.alt = productS.title || '';
        }

        var sizeSingleS = document.createElement('select');
        sizeSingleS.className = 'ofiles-sale-select ofiles-sale-size-select';
        sizeSingleS.setAttribute('data-reward-index', rewardIndex);

        if (productS && productS.variants) {
          var availS = productS.variants.filter(function (v) { return v.available; });
          var oneSizeS = isOneSizeProduct(availS);

          availS.forEach(function (v) {
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title === 'Default Title' ? 'One Size' : v.title;
            sizeSingleS.appendChild(opt);
          });

          if (oneSizeS) sizeSingleS.style.display = 'none';
        }

        detailsColS.appendChild(sizeSingleS);
        rowS.appendChild(detailsColS);
        section.appendChild(rowS);
      }

      rewardContainer.appendChild(section);
    });

    modal.appendChild(rewardContainer);

    // Add to bag button
    var cta = document.createElement('button');
    cta.className = 'ofiles-sale-cta';
    cta.textContent = 'ADD TO BAG';
    modal.appendChild(cta);

    // Continue link
    var cont = document.createElement('button');
    cont.className = 'ofiles-sale-continue';
    cont.textContent = 'CONTINUE';
    modal.appendChild(cont);

    overlay.appendChild(modal);

    // ── EVENTS ──

    function closePopup() {
      overlay.style.opacity = '0';
      modal.style.transform = 'translateY(8px)';
      setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        popupOpen = false;
      }, 300);
    }

    closeBtn.addEventListener('click', closePopup);
    cont.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    // ESC key
    function onEsc(e) {
      if (e.key === 'Escape') {
        closePopup();
        document.removeEventListener('keydown', onEsc);
      }
    }
    document.addEventListener('keydown', onEsc);

    // Add to bag
    cta.addEventListener('click', function () {
      var items = [];

      // Collect from visual-choice cards (only the selected card)
      var visualRewards = modal.querySelectorAll('[data-visual-choice="true"]');
      var visualHandles = [];
      visualRewards.forEach(function (section) {
        var selectedCard = section.querySelector('.ofiles-sale-card.is-selected');
        if (selectedCard) {
          var cardSize = selectedCard.querySelector('.ofiles-sale-card-size');
          if (cardSize && cardSize.value) {
            items.push({ id: parseInt(cardSize.value, 10), quantity: 1 });
            visualHandles.push(selectedCard.getAttribute('data-handle'));
          }
        }
      });

      // Collect from regular size selects (skip those inside visual-choice cards)
      var sizeSelects = modal.querySelectorAll('.ofiles-sale-size-select:not(.ofiles-sale-card-size)');
      sizeSelects.forEach(function (sel) {
        var variantId = sel.value;
        if (variantId) {
          items.push({ id: parseInt(variantId, 10), quantity: 1 });
        }
      });

      if (items.length === 0) return;

      cta.textContent = 'ADDING...';
      cta.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json(); })
        .then(function (response) {
          if (response.status) {
            // Error
            cta.textContent = 'UNAVAILABLE — TRY ANOTHER SIZE';
            cta.disabled = false;
            return;
          }

          cta.textContent = 'ADDED';

          // Update cart drawer / notification
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sale-popup' });
          }

          // Update cart bubble count
          updateCartBubble();

          setTimeout(closePopup, 800);
        })
        .catch(function () {
          cta.textContent = 'ERROR — PLEASE TRY AGAIN';
          cta.disabled = false;
        });
    });

    return overlay;
  }

  // ─── POPULATE SIZE SELECT ────────────────────
  function populateSizeSelect(sizeSelect, img, handle, productsMap) {
    // Clear existing
    sizeSelect.innerHTML = '';

    var product = productsMap[handle];
    if (!product) {
      // Need to fetch
      fetchProduct(handle).then(function (p) {
        if (p) {
          productsMap[handle] = p;
          fillSizeOptions(sizeSelect, p);
          updateRewardImage(img, p);
        }
      });
    } else {
      fillSizeOptions(sizeSelect, product);
      updateRewardImage(img, product);
    }
  }

  // Helper: check if a product's available variants are just one-size
  function isOneSizeProduct(availableVariants) {
    if (availableVariants.length !== 1) return false;
    var t = availableVariants[0].title.toLowerCase();
    return t === 'default title' || t === 'one size';
  }

  function fillSizeOptions(select, product) {
    select.innerHTML = '';
    if (product && product.variants) {
      var availableVariants = product.variants.filter(function (v) { return v.available; });
      var oneSize = isOneSizeProduct(availableVariants);

      availableVariants.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title === 'Default Title' ? 'One Size' : v.title;
        select.appendChild(opt);
      });

      // Hide select if only one-size variant
      select.style.display = oneSize ? 'none' : '';
    }
  }

  function updateRewardImage(img, product) {
    if (!img || !product) return;
    var src = product.featured_image || (product.images && product.images[0]) || (product.image && product.image.src);
    if (src) {
      img.src = 'https:' + src.replace(/\.([a-z]+)(\?.*)?$/, '_300x.$1$2');
      img.alt = product.title || '';
    }
  }

  // ─── CART BUBBLE UPDATE ──────────────────────
  function updateCartBubble() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble');
        bubbles.forEach(function (el) {
          if (el.querySelector('span')) {
            var span = el.querySelector('span[aria-hidden="true"]');
            if (span) span.textContent = cart.item_count;
          }
        });
        // Also update last known state
        lastCartItems = cart.items || [];
      });
  }

  // ─── CART WATCHDOG ────────────────────────────
  // If a customer removes a qualifying product,
  // automatically remove orphaned hats that were
  // added via the popup. Only hats need this — all
  // other rewards are protected by Shopify discounts.
  // ──────────────────────────────────────────────
  function validateCart() {
    if (isValidating) return;
    isValidating = true;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var cartHandles = [];
        items.forEach(function (item) {
          if (cartHandles.indexOf(item.handle) === -1) {
            cartHandles.push(item.handle);
          }
        });

        // Check only hat items for orphaned triggers
        var updates = {};
        var hasOrphans = false;

        items.forEach(function (item) {
          var triggers = HAT_TRIGGERS[item.handle];
          if (!triggers || triggers.length === 0) return; // Not a hat

          var hasTrigger = false;
          for (var i = 0; i < triggers.length; i++) {
            if (cartHandles.indexOf(triggers[i]) !== -1) {
              hasTrigger = true;
              break;
            }
          }

          if (!hasTrigger) {
            updates[item.key] = 0;
            hasOrphans = true;
          }
        });

        if (hasOrphans) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates: updates })
          })
            .then(function () {
              isValidating = false;
              updateCartBubble();
              if (window.location.pathname === '/cart') {
                window.location.reload();
              }
            })
            .catch(function () { isValidating = false; });
        } else {
          isValidating = false;
        }

        lastCartItems = items;
      })
      .catch(function () { isValidating = false; });
  }

  // ─── SHOW POPUP ──────────────────────────────
  function showSalePopup(rule) {
    if (popupOpen) return;
    popupOpen = true;

    // Collect all unique handles we need to fetch
    var allHandles = [];
    rule.rewards.forEach(function (reward) {
      reward.handles.forEach(function (h) {
        if (allHandles.indexOf(h) === -1) allHandles.push(h);
      });
    });

    // Fetch all product data in parallel
    Promise.all(allHandles.map(fetchProduct)).then(function (products) {
      var productsMap = {};
      products.forEach(function (p, idx) {
        if (p) productsMap[allHandles[idx]] = p;
      });

      var overlay = buildPopup(rule, productsMap);
      document.body.appendChild(overlay);

      // Animate in
      requestAnimationFrame(function () {
        overlay.style.opacity = '1';
        overlay.querySelector('.ofiles-sale-modal').style.transform = 'translateY(0)';
      });
    });
  }

  // ─── MAIN LISTENER ───────────────────────────
  // Wait for DOMContentLoaded to ensure deferred scripts
  // (pubsub.js, constants.js) have executed first.
  function initSalePopup() {
    // Snapshot cart state
    getCartItems().then(function (items) {
      lastCartItems = items;
    });

    // Subscribe to Shopify's built-in pub/sub cart update
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        // Don't react to our own popup additions or watchdog removals
        if (event && event.source === 'sale-popup') {
          getCartItems().then(function (items) { lastCartItems = items; });
          return;
        }

        // Small delay to let cart settle
        setTimeout(function () {
          getCartItems().then(function (newItems) {
            var addedHandles = findNewlyAddedHandles(lastCartItems, newItems);
            lastCartItems = newItems;

            // Check for orphaned rewards (trigger product removed)
            validateCart();

            if (addedHandles.length === 0) return;

            var rule = findMatchingRule(addedHandles);
            if (rule) {
              showSalePopup(rule);
            }
          });
        }, 400);
      });
    } else {
      console.warn('[sale-popup] pub/sub not available — subscribe:', typeof subscribe, 'PUB_SUB_EVENTS:', typeof PUB_SUB_EVENTS);
    }
  }

  // ─── CART PAGE WATCHDOG ───────────────────────
  // On the /cart page, also validate whenever the
  // page regains focus (covers manual item removal
  // that may not fire pub/sub events).
  // ──────────────────────────────────────────────
  function initCartPageWatchdog() {
    if (window.location.pathname === '/cart') {
      // Validate on initial load
      setTimeout(validateCart, 1000);

      // Validate when page regains focus (e.g. after tab switch)
      window.addEventListener('focus', function () {
        setTimeout(validateCart, 500);
      });

      // Watch for DOM changes on the cart page (item removals)
      var cartForm = document.querySelector('form[action="/cart"]') ||
                     document.querySelector('.cart') ||
                     document.querySelector('[data-cart]');
      if (cartForm) {
        var observer = new MutationObserver(function () {
          setTimeout(validateCart, 600);
        });
        observer.observe(cartForm, { childList: true, subtree: true });
      }
    }
  }

  // Deferred scripts run on DOMContentLoaded, so we wait for that
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSalePopup();
      initCartPageWatchdog();
    });
  } else {
    initSalePopup();
    initCartPageWatchdog();
  }

})();
